import React from "react";
import { BiSolidCameraPlus } from "react-icons/bi";
import { VscOpenPreview } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa";
//import { InputMask } from '@react-input/mask';
//import Datepicker from "react-tailwindcss-datepicker"; 
import { Portal } from 'react-portal';
import variables from "../rests/variables";
import statelist from "../../assets/json/widget_states.json";
import countrylist from "../../assets/json/widget_countries.json";
import Rests from "../rests/services";
import { formatInTimeZone } from 'date-fns-tz';
import SharedFunctions from "../classes/sharedfunctions";
import Pagination from "../rests/pagination";
import Connect from "../landingpage/Connect";
import * as SmartyStreetsSDK from 'smartystreets-javascript-sdk';

const shared = new SharedFunctions();
const rests = new Rests();
const timeZone = 'America/Chicago';

/*const PhoneField = (props) => {
    
    const [showdrop, setDrop] = React.useState(0);
    const handleShowDrop = (e) => {
        
        if (parseInt(showdrop)) {
            setDrop(0)
        } else {
            setDrop(1)
        }
    }
    return (

    <>
        <div className="relative">
            <div className="flex items-center relative">
                
                <label htmlFor="phone-input" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Phone number:</label>
                <div className="relative w-full">
                    <InputMask mask="(___) ___-____" replacement={{ _: /\d/ }} id="phone" name="phone" className="block rounded-e-md px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" defaultValue={props.phoneVal} onBlur={(e)=> props.handleChange(e,0)} required/>
                    
                </div>
            </div>
            {parseInt(showdrop) === 1 ? <div id="dropdown-phone" className="z-200 bg-white divide-y divide-gray-100 rounded-lg shadow w-52 dark:bg-gray-700">
                    <ul className="py-2 px-0 text-sm text-tprimary dark:text-tprimary" aria-labelledby="dropdown-phone-button">
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-left text-tprimary hover:bg-gray-100 dark:text-tprimary dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg fill="none" aria-hidden="true" className="h-4 w-4 me-2" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#D02F44" fillRule="evenodd" d="M19.6.5H0v.933h19.6V.5zm0 1.867H0V3.3h19.6v-.933zM0 4.233h19.6v.934H0v-.934zM19.6 6.1H0v.933h19.6V6.1zM0 7.967h19.6V8.9H0v-.933zm19.6 1.866H0v.934h19.6v-.934zM0 11.7h19.6v.933H0V11.7zm19.6 1.867H0v.933h19.6v-.933z" clipRule="evenodd"/><path fill="#46467F" d="M0 .5h8.4v6.533H0z"/><g filter="url(#filter0_d_343_121520)"><path fill="url(#paint0_linear_343_121520)" fillRule="evenodd" d="M1.867 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.866 0a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM7.467 1.9a.467.467 0 11-.934 0 .467.467 0 01.934 0zM2.333 3.3a.467.467 0 100-.933.467.467 0 000 .933zm2.334-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm1.4.467a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.934 0 .467.467 0 01.934 0zm-2.334.466a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.466a.467.467 0 11-.933 0 .467.467 0 01.933 0zM1.4 4.233a.467.467 0 100-.933.467.467 0 000 .933zm1.4.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zm1.4.467a.467.467 0 100-.934.467.467 0 000 .934zM6.533 4.7a.467.467 0 11-.933 0 .467.467 0 01.933 0zM7 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.933 0 .467.467 0 01.933 0zM3.267 6.1a.467.467 0 100-.933.467.467 0 000 .933zm-1.4-.467a.467.467 0 11-.934 0 .467.467 0 01.934 0z" clipRule="evenodd"/></g></g><defs><linearGradient id="paint0_linear_343_121520" x1=".933" x2=".933" y1="1.433" y2="6.1" gradientUnits="userSpaceOnUse"><stop stopColor="#fff"/><stop offset="1" stopColor="#F0F0F0"/></linearGradient><filter id="filter0_d_343_121520" width="6.533" height="5.667" x=".933" y="1.433" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_343_121520"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_343_121520" result="shape"/></filter></defs></svg>
                                    United States (+1)
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg className="h-4 w-4 me-2" fill="none" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#0A17A7" d="M0 .5h19.6v14H0z"/><path fill="#fff" fillRule="evenodd" d="M-.898-.842L7.467 4.8V-.433h4.667V4.8l8.364-5.642L21.542.706l-6.614 4.46H19.6v4.667h-4.672l6.614 4.46-1.044 1.549-8.365-5.642v5.233H7.467V10.2l-8.365 5.642-1.043-1.548 6.613-4.46H0V5.166h4.672L-1.941.706-.898-.842z" clipRule="evenodd"/><path stroke="#DB1F35" strokeLinecap="round" strokeWidth=".667" d="M13.067 4.933L21.933-.9M14.009 10.088l7.947 5.357M5.604 4.917L-2.686-.67M6.503 10.024l-9.189 6.093"/><path fill="#E6273E" fillRule="evenodd" d="M0 8.9h8.4v5.6h2.8V8.9h8.4V6.1h-8.4V.5H8.4v5.6H0v2.8z" clipRule="evenodd"/></g></svg>
                                    United Kingdom (+44)
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg className="h-4 w-4 me-2" fill="none" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#0A17A7" d="M0 .5h19.6v14H0z"/><path fill="#fff" stroke="#fff" strokeWidth=".667" d="M0 .167h-.901l.684.586 3.15 2.7v.609L-.194 6.295l-.14.1v1.24l.51-.319L3.83 5.033h.73L7.7 7.276a.488.488 0 00.601-.767L5.467 4.08v-.608l2.987-2.134a.667.667 0 00.28-.543V-.1l-.51.318L4.57 2.5h-.73L.66.229.572.167H0z"/><path fill="url(#paint0_linear_374_135177)" fillRule="evenodd" d="M0 2.833V4.7h3.267v2.133c0 .369.298.667.666.667h.534a.667.667 0 00.666-.667V4.7H8.2a.667.667 0 00.667-.667V3.5a.667.667 0 00-.667-.667H5.133V.5H3.267v2.333H0z" clipRule="evenodd"/><path fill="url(#paint1_linear_374_135177)" fillRule="evenodd" d="M0 3.3h3.733V.5h.934v2.8H8.4v.933H4.667v2.8h-.934v-2.8H0V3.3z" clipRule="evenodd"/><path fill="#fff" fillRule="evenodd" d="M4.2 11.933l-.823.433.157-.916-.666-.65.92-.133.412-.834.411.834.92.134-.665.649.157.916-.823-.433zm9.8.7l-.66.194.194-.66-.194-.66.66.193.66-.193-.193.66.193.66-.66-.194zm0-8.866l-.66.193.194-.66-.194-.66.66.193.66-.193-.193.66.193.66-.66-.193zm2.8 2.8l-.66.193.193-.66-.193-.66.66.193.66-.193-.193.66.193.66-.66-.193zm-5.6.933l-.66.193.193-.66-.193-.66.66.194.66-.194-.193.66.193.66-.66-.193zm4.2 1.167l-.33.096.096-.33-.096-.33.33.097.33-.097-.097.33.097.33-.33-.096z" clipRule="evenodd"/></g><defs><linearGradient id="paint0_linear_374_135177" x1="0" x2="0" y1=".5" y2="7.5" gradientUnits="userSpaceOnUse"><stop stopColor="#fff"/><stop offset="1" stopColor="#F0F0F0"/></linearGradient><linearGradient id="paint1_linear_374_135177" x1="0" x2="0" y1=".5" y2="7.033" gradientUnits="userSpaceOnUse"><stop stopColor="#FF2E3B"/><stop offset="1" stopColor="#FC0D1B"/></linearGradient></defs></svg>
                                    Australia (+61)
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg className="w-4 h-4 me-2" fill="none" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#262626" fillRule="evenodd" d="M0 5.167h19.6V.5H0v4.667z" clipRule="evenodd"/><g filter="url(#filter0_d_374_135180)"><path fill="#F01515" fillRule="evenodd" d="M0 9.833h19.6V5.167H0v4.666z" clipRule="evenodd"/></g><g filter="url(#filter1_d_374_135180)"><path fill="#FFD521" fillRule="evenodd" d="M0 14.5h19.6V9.833H0V14.5z" clipRule="evenodd"/></g></g><defs><filter id="filter0_d_374_135180" width="19.6" height="4.667" x="0" y="5.167" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_374_135180"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_374_135180" result="shape"/></filter><filter id="filter1_d_374_135180" width="19.6" height="4.667" x="0" y="9.833" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_374_135180"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_374_135180" result="shape"/></filter></defs></svg>
                                    Germany (+49)
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg className="w-4 h-4 me-2" fill="none" viewBox="0 0 20 15"><rect width="19.1" height="13.5" x=".25" y=".75" fill="#fff" stroke="#F5F5F5" strokeWidth=".5" rx="1.75"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.1" height="13.5" x=".25" y=".75" fill="#fff" stroke="#fff" strokeWidth=".5" rx="1.75"/></mask><g mask="url(#a)"><path fill="#F44653" d="M13.067.5H19.6v14h-6.533z"/><path fill="#1035BB" fillRule="evenodd" d="M0 14.5h6.533V.5H0v14z" clipRule="evenodd"/></g></svg>
                                    France (+33)
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" className="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                                <span className="inline-flex items-center">
                                    <svg className="w-4 h-4 me-2" fill="none" viewBox="0 0 20 15"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/><mask id="a" style={{maskType: 'luminance'}} width="20" height="15" x="0" y="0" maskUnits="userSpaceOnUse"><rect width="19.6" height="14" y=".5" fill="#fff" rx="2"/></mask><g mask="url(#a)"><path fill="#262626" fillRule="evenodd" d="M0 5.167h19.6V.5H0v4.667z" clipRule="evenodd"/><g filter="url(#filter0_d_374_135180)"><path fill="#F01515" fillRule="evenodd" d="M0 9.833h19.6V5.167H0v4.666z" clipRule="evenodd"/></g><g filter="url(#filter1_d_374_135180)"><path fill="#FFD521" fillRule="evenodd" d="M0 14.5h19.6V9.833H0V14.5z" clipRule="evenodd"/></g></g><defs><filter id="filter0_d_374_135180" width="19.6" height="4.667" x="0" y="5.167" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_374_135180"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_374_135180" result="shape"/></filter><filter id="filter1_d_374_135180" width="19.6" height="4.667" x="0" y="9.833" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_374_135180"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_374_135180" result="shape"/></filter></defs></svg>
                                    Germany (+49)
                                </span>
                            </button>
                        </li>
                    </ul>
                </div> : <></>}
        </div>
    </>

    )
}*/
const TransactionView = (props) => {
    const wt = props?.workingtransaction?.length ? props.workingtransaction[0].properties : {};
    const wtItems = props?.workingtransaction?.length ? props?.workingtransaction[0].items : [];
    
    let fName = wt.billing_first_name || '';
    let lName = wt.billing_last_name || '';
    let fullName = fName + ' ' + lName;
    let phone = shared.formatPhone(wt.billing_phone) || '';
    let email = wt.billing_email ? wt.billing_email : (props.memInfo && props.memInfo.email ? props.memInfo.email : '');
    let orderDate = wt.transaction_date ? formatInTimeZone(wt.transaction_date, timeZone, 'MMMM dd, yyyy') : '';
    
   // format(new Date(props.workingtransaction[0].transactionDate), 'MMMM dd, yyyy')
    let docID = wt.hs_object_id || 0;
    let filterot = props.workingmember && props.workingmember.transactions ? props.workingmember.transactions.filter(t=> t.id === docID) : [];
   
    if (!filterot.length) {
        filterot = props.memInfo && props.memInfo.transactions && props.memInfo.transactions.length ? props.memInfo.transactions.filter(t=> t.id === docID) : [];
    }
   
    let orderTotal = parseFloat(wt.amount) || 0;
    let shipping = parseFloat(wt.shipping_amount) || 0;
    //let tax = 0;
    
    
    /*if (filterot.length && parseInt(filterot[0].eventTotal)) {
        orderTotal = filterot[0].eventTotal;
       
    } else if (filterot.length && parseInt(filterot[0].donationTotal)) {
        orderTotal = filterot[0].donationTotal;
       
    } else if (filterot.length && parseInt(filterot[0].productTotal)) {
        orderTotal = filterot[0].productTotal;
       
    }*/
    
    
    let discount = parseFloat(wt.coupon_discount_amount) || (parseFloat(wt.coupon_discount_percent) || 0);
    let itemtotal = 0;
    //console.log(props.workingtransaction);
    for (let t in wtItems) {
        
        let transObj = wtItems[t];
      /*  if (transObj.productDiscountAmount) {
            discount = discount + transObj.productDiscountAmount
        }*/
        if (transObj.price != null) {
            //if part of an Inprov campaign it will have a project code and quantity should be 1
            let qty = parseInt(transObj.quantity) || 1;
            itemtotal = itemtotal + (parseFloat(transObj.price) * qty)
        }
    }
    
    let subTotal = itemtotal;
    subTotal = subTotal ? shared.numberWithCommas(parseFloat(subTotal).toFixed(2)) : 0;
    orderTotal = orderTotal === 0 ? (itemtotal - discount) + shipping : (orderTotal - discount) + shipping;
    orderTotal = shared.numberWithCommas(parseFloat(orderTotal).toFixed(2))

    return (
        <>
            <div className="modal" style={{display: 'block'}}>
                <div className="modalbg fixed w-full bg-modalbg h-100" onClick={(e) => props.closeView()}></div>
                    <div className="modal-content opacity-1 mt-[8%] ml-auto mr-auto max-w-[50%] p-20 bg-white h-auto">
                        <div className="modalclose relative text-right w-full flex justify-end" >
                            <IoMdClose size={24} className="cursor-pointer" onClick={(e) => props.closeView()}/>
                        </div>
                        
                        <div className="flex w-full items-center justify-center ">
                            <div className="w-[95%] px-6 shadow-lg border border-gray-200 rounded-lg shadow-gcard">
                                <img src="https://gpspartner.org/wp-content/uploads/sites/6/2017/09/gpslogo.png" alt="chippz" className="mx-auto w-[120px] py-4" />
                                <div className="flex flex-col justify-center items-center gap-2">
                                    <h4 className="text-tprimary font-semibold">Transaction Item</h4>
                                    
                                </div>
                                <div className="flex flex-col gap-3 border-b py-6 text-sm">
                                    <p className="flex justify-between">
                                        <span className="text-tsecondary">Document Number:</span>
                                        <span className="text-tprimary">{docID}</span>
                                    </p>
                                    <p className="flex justify-between">
                                        <span className="text-tsecondary">Transaction Date:</span>
                                        <span className="text-tprimary">{orderDate}</span>
                                    </p>
                                    
                                    <p className="flex justify-between">
                                        <span className="text-tsecondary">Customer:</span>
                                        <span className="text-tprimary">{fullName}</span>
                                    </p>
                                </div>
                                <div className="flex flex-col gap-3 pb-6 pt-2 text-sm">
                                <table className="w-full text-left">
                                    <thead>
                                    <tr className="flex">
                                        <th className="w-full py-2 text-tprimary">Item</th>
                                        <th className="min-w-[64px] py-2 text-tprimary text-center">QTY</th>
                                        <th className="min-w-[64px] py-2 text-tprimary">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {props.workingtransaction.length && props.workingtransaction[0].projectCodeDescription && props.workingtransaction[0].productCode? 
                                        <tr className="flex">
                                            <td className="flex-1 py-1 text-tprimary">Donation</td>
                                            <td className="min-w-[64px] text-tprimary text-center">1</td>
                                            <td className="min-w-[64px] text-tprimary text-right">${orderTotal}</td>
                                            
                                        </tr>
                                    : <></>}
                                    {wtItems?.length ? wtItems.map((t, idx)=> {
                                
                                        return (
                                            
                                               
                                            <tr key={t.hs_product_id} className="flex">
                                                <td className="flex-1 py-1 text-tprimary">{t.description.trim()}</td>
                                                

                                               
                                                
                                                <td className="min-w-[64px] text-tprimary text-center">
                                                    
                                                    <span>{t.quantity}</span>
                                                   
                                                    
                                                </td>
                                                <td className="min-w-[64px] text-tprimary text-right">${shared.numberWithCommas(parseFloat(t.price).toFixed(2))}</td>
                                               
                                            </tr>
                                            
                                            )
                                        })
                                    : <></>}
                                        <tr>
                                            <td colSpan={"3"} className="border-b border-dotted"></td>
                                        </tr>
                                        {subTotal ? <tr className="flex pt-3">
                                            <td className="flex-1 py-1 text-tprimary">&nbsp;</td>
                                            <td className="min-w-[75px] text-tprimary"><b>SubTotal:</b></td>
                                            <td className="min-w-[64px] text-tprimary text-right">${subTotal}</td>
                                        </tr> : <></>}
                                        {shipping ? <tr className="flex pt-3">
                                            <td className="flex-1 py-1 text-tprimary">&nbsp;</td>
                                            <td className="min-w-[75px] text-tprimary"><b>Shipping:</b></td>
                                            <td className="min-w-[64px] text-tprimary text-right">${shared.numberWithCommas(parseFloat(shipping).toFixed(2))}</td>
                                        </tr> : <></>}
                                    
                                        {discount ? <tr className="flex pt-3">
                                            <td className="flex-1 py-1 text-tprimary">&nbsp;</td>
                                            <td className="min-w-[75px] text-tprimary"><b>Discount:</b></td>
                                            <td className="min-w-[64px] text-tprimary text-right">(${shared.numberWithCommas(parseFloat(discount).toFixed(2))})</td>
                                        </tr> : <></>}
                                        <tr className="flex pt-3 border-t border-dotted">
                                            <td className="flex-1 py-1 text-tprimary">&nbsp;</td>
                                            <td className="min-w-[75px] text-tprimary"><b>Total:</b></td>
                                            <td className="min-w-[64px] text-tprimary text-right">${orderTotal}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className=" border-b border border-dotted"></div>
                                <div className="py-4 justify-center items-center flex flex-col gap-2">
                                    {email ? <p className="flex gap-2 text-tprimary"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M21.3 12.23h-3.48c-.98 0-1.85.54-2.29 1.42l-.84 1.66c-.2.4-.6.65-1.04.65h-3.28c-.31 0-.75-.07-1.04-.65l-.84-1.65a2.567 2.567 0 0 0-2.29-1.42H2.7c-.39 0-.7.31-.7.7v3.26C2 19.83 4.18 22 7.82 22h8.38c3.43 0 5.54-1.88 5.8-5.22v-3.85c0-.38-.31-.7-.7-.7ZM12.75 2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2h1.5V2Z" fill="#000"></path><path d="M22 9.81v1.04a2.06 2.06 0 0 0-.7-.12h-3.48c-1.55 0-2.94.86-3.63 2.24l-.75 1.48h-2.86l-.75-1.47a4.026 4.026 0 0 0-3.63-2.25H2.7c-.24 0-.48.04-.7.12V9.81C2 6.17 4.17 4 7.81 4h3.44v3.19l-.72-.72a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l2 2c.01.01.02.01.02.02a.753.753 0 0 0 .51.2c.1 0 .19-.02.28-.06.09-.03.18-.09.25-.16l2-2c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.72.72V4h3.44C19.83 4 22 6.17 22 9.81Z" fill="#000"></path></svg> {email}</p> : <></>}
                                    {phone ? <p className="flex gap-2 text-tprimary"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"><path fill="#000" d="M11.05 14.95L9.2 16.8c-.39.39-1.01.39-1.41.01-.11-.11-.22-.21-.33-.32a28.414 28.414 0 01-2.79-3.27c-.82-1.14-1.48-2.28-1.96-3.41C2.24 8.67 2 7.58 2 6.54c0-.68.12-1.33.36-1.93.24-.61.62-1.17 1.15-1.67C4.15 2.31 4.85 2 5.59 2c.28 0 .56.06.81.18.26.12.49.3.67.56l2.32 3.27c.18.25.31.48.4.7.09.21.14.42.14.61 0 .24-.07.48-.21.71-.13.23-.32.47-.56.71l-.76.79c-.11.11-.16.24-.16.4 0 .08.01.15.03.23.03.08.06.14.08.2.18.33.49.76.93 1.28.45.52.93 1.05 1.45 1.58.1.1.21.2.31.3.4.39.41 1.03.01 1.43zM21.97 18.33a2.54 2.54 0 01-.25 1.09c-.17.36-.39.7-.68 1.02-.49.54-1.03.93-1.64 1.18-.01 0-.02.01-.03.01-.59.24-1.23.37-1.92.37-1.02 0-2.11-.24-3.26-.73s-2.3-1.15-3.44-1.98c-.39-.29-.78-.58-1.15-.89l3.27-3.27c.28.21.53.37.74.48.05.02.11.05.18.08.08.03.16.04.25.04.17 0 .3-.06.41-.17l.76-.75c.25-.25.49-.44.72-.56.23-.14.46-.21.71-.21.19 0 .39.04.61.13.22.09.45.22.7.39l3.31 2.35c.26.18.44.39.55.64.1.25.16.5.16.78z"></path></svg> {phone}</p>: <></>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const ListItem = (props) => {
    
    const rowItem = props.opt.properties;
    let orderTotal = rowItem.amount;
    let shipping = rowItem.shipping_amount ? props.opt.shipping_amount : 0;
    //let tax = props.opt.taxTotal ? props.opt.taxTotal : 0;
    let discount = 0;
    /*if (rowItem.transaction_type == "Donation")  {
        orderTotal = rowItem.amount;
    } else if (props.opt.eventTotal) {
        orderTotal = props.opt.eventTotal;
    } else if (props.opt.productTotal) {
        orderTotal = props.opt.productTotal;
    }*/

    let listtype = rowItem.transaction_type == "Donation" ? 'Donation' : '';
    if (props.opt.donationTotal && !props.opt.productTotal) {
        
        if (props.opt.response.type === 'EVENTACK') {
            listtype = 'Event';
        } else {
            listtype = 'Donation';
        }
    } else if (props.opt.eventTotal || (props.opt.response && props.opt.response.type && props.opt.response.type.indexOf('EVENT') !== -1) && !props.opt.productTotal ) {
       
        
        listtype = 'Event';
    } else if (props.opt.productTotal && !props.opt.donationTotal || (props.opt.response && props.opt.response.type && props.opt.response.type.indexOf('ORDER') !== -1)) {
        
        listtype = 'Order';
        orderTotal = (orderTotal - discount) + shipping;
    } else if (props.opt.productTotal && props.opt.donationTotal || (props.opt.response && props.opt.response.type && props.opt.response.type.indexOf('ORDER') !== -1)) {
        listtype = 'Campaign Donation';
        
    }

    

    
    return (
        <>
            <tr className="bg-white border-dashed border-b ">
                <td className="px-6 py-4">${shared.numberWithCommas(parseFloat(orderTotal).toFixed(2))}</td>
                <td className="px-6 py-4">{rowItem.hs_object_id}</td>
                <td className="px-6 py-4">{listtype}</td>
                <td>{rowItem.order_date ? formatInTimeZone(rowItem.order_date, timeZone, 'MMMM dd, yyyy') : ''}</td>
                <td><VscOpenPreview size={28} className="cursor-pointer" onClick={(e)=> props.handleView(rowItem.hs_object_id)}/></td>
            </tr>
        </>
    )
}

const SocialMediaBlock = (props) => {
    return (
        <div className="flex flex-row space-x-2">
            <div className="col-md-5 my-3">
                <select id="ssmtype" name="ssmtype" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={props.type} onChange={(e)=> props.handleChange(e,props.idx)}>
                <option value="">Select</option>
                {props.socialmediatypes &&
                    props.socialmediatypes.map ((opt) => ( <option key={Math.random()} value={opt.id} >
                        {opt.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-md-5 my-3">
                <input type="text" id="ssmlink" name="ssmlink" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={props.link} onBlur={(e)=> props.handleChange(e,props.idx)}/>
            </div>
            <div className="col-md-2 my-3">
                <div className="flex flex-row space-x-2">
                    <FaPlus className="cursor-pointer" onClick={(e) => props.handleAddSSM()}/>
                    <FaRegTrashAlt className="cursor-pointer" onClick={(e)=> props.handleDeleteSSM(props.idx)}/>
                </div>
            </div>
        </div>
    )
}

class MemberProfile extends React.Component {
    constructor(props) {
        super(props);
        this.badges = {
            aa: {
                badge: '/assets/images/badges/digital_badge_aa.png'
            },
            bc: {
                badge: '/assets/images/badges/digital_badge_bc.png'
            },
            bcvip: {
                badge: '/assets/images/badges/digital_badge_bcvip.png'
            },
            vip: {
                badge: '/assets/images/badges/digital_badge_vip.png'
            },
            gpsvip: {
                badge: '/assets/images/badges/digital_badge_vip.png'
            }
        };

        this.state = {
            memberdonorInfo: this.props.memberdonorInfo, 
            addressOptions: [],
            billingaddressOptions: [],
            badgeImg: '',
            badgeStyle: {},
            showprogress: false, 
            togglebutton: false,
            countryID: 1, 
            transview: '', 
            activeIndex: 0,
            biocharacters: 0,
            acceptedfile: true,
            filtering: false,
            filteringoption: '',
            showphonedropdowns: false,
            workingtransaction: [], 
            memberstate: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.state ? this.props.memberdonorInfo.address.state : '', stateoptions: [],
            items: this.props.memberdonorInfo.transactions,
            pageInfo: this.props.pageInfo,
            page: this.props.page,
            pickerdate: {
                startDate: null,
                endDate: null
            },
            workingmember: {
                donoraccount: this.props.memberdonorInfo.donoraccount,
                firstname: this.props.memberdonorInfo.firstName,
                lastname: this.props.memberdonorInfo.lastName,
                email: this.props.memberdonorInfo.email,
                partner: this.props.memberdonorInfo.partner,
                partnerdesc: this.props.memberdonorInfo.partnerdesc,
                address1: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.line1 ? this.props.memberdonorInfo.address.line1 : '',
                address2: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.line2 ? this.props.memberdonorInfo.address.line2 : '',
                city: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.city ? this.props.memberdonorInfo.address.city : '',
                state: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.state ? this.props.memberdonorInfo.address.state : '',
                zip: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.postalCode ? this.props.memberdonorInfo.address.postalCode : '',
                country: this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.country ? this.props.memberdonorInfo.address.country : '',
                phone: this.props.memberdonorInfo.phone && this.props.memberdonorInfo.phone.phoneNumber ? this.props.memberdonorInfo.phone.phoneNumber : '',
                bio: '',
                ssms: [{
                    type: '',
                    link: ''
                }],
                transactions: this.props.memberdonorInfo.transactions,
                photo: '',
                addressID: 0,
                phoneID: 0,
                emailID: 0,
                photoapproved: 0
            }
        };
        
        this.handleAddSSM = this.handleAddSSM.bind(this);
        this.handleDeleteSSM = this.handleDeleteSSM.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleGotoPage = this.handleGotoPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.handleOpenButton = this.handleOpenButton.bind(this);
        this.handlePhotoUpload = this.handlePhotoUpload.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.closeView = this.closeView.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.autocompleteAddress = this.autocompleteAddress.bind(this);
        this.filladdress = this.filladdress.bind(this);
        this.getFilteredListItems = this.getFilteredListItems.bind(this);
        this.getmember = this.getmember.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.showProgress = this.showProgress.bind(this);
        this.closeProgress = this.closeProgress.bind(this);

        this.socialmediatypes = [
            {id: 'facebook', name: 'Facebook', idvalue: '', value: 'Facebook'},
            {id: 'instagram', name: 'Instagram', idvalue: '', value: 'Instagram'},
            {id: 'twitter', name: 'Twitter', idvalue: '', value: 'Twitter'},
            {id: 'linkedin', name: 'LinkedIn', idvalue: '', value: 'LinkedIn'},
            {id: 'youtube', name: 'YouTube', idvalue: '', value: 'YouTube'},
            {id: 'website', name: 'Website', idvalue: '', value: 'Website'}
        ]

        this.tabs = [
            {cat: "All", id: 1, slug: 'all'},
            {cat: "Donations", id: 1, slug: 'donations'},
            {cat: "Events", id: 2, slug: 'events'},
            {cat: "Orders", id: 3, slug: 'orders'}
        ];

        let addprops = {
            handleAddSSM: this.handleAddSSM,
            handleDeleteSSM: this.handleDeleteSSM,
            handleGotoPage: this.handleGotoPage,
            handleChange: this.handleChange,
            handleView: this.handleView,
            closeView: this.closeView,
            workingtransaction: this.props.workingtransaction,
            memberdonorInfo: this.props.memberdonorInfo,
            workingmember: this.props.workingmember,
            socialmediatypes: this.socialmediatypes,
            showphonedropdowns: this.state.showphonedropdowns
        }

        this.allprops = {...props, ...addprops};
        
        this.countryoptions = [];
        statelist.map((s) => {
            if (s.CountryID === this.state.countryID) {
                this.state.stateoptions.push({
                    id: s.Abbreviation,
                    name: s.Name
                })
            }
            return s
        })
        this.memberstate = this.props.memberdonorInfo.address && this.props.memberdonorInfo.address.state ? this.props.memberdonorInfo.address.state : ''
        
        this.countryoptions = countrylist.map((c) => {
            return {
                id: c.TwoLetterISOCode,
                name: c.Name
            }
        })

        this.getmember();
       
    }
    
    handleAddSSM() {
        this.state.workingmember.ssms.push({
            type: '',
            link: ''
        })
        this.setState({workingmember: this.state.workingmember});
    }

    handleDeleteSSM(idx) {
        let currmem = this.state.workingmember;
        let newssms = [];
        for (let s in this.state.workingmember.ssms) {
            if (parseInt(s) !== parseInt(idx)) {
                newssms.push(this.state.workingmember.ssms[s]);
            }
        }
        currmem.ssms = newssms;
        this.setState({workingmember: currmem});
    }

    getFilteredListItems (listslug) {
        
        let filterlist = [];
        switch (listslug) {
            case "donations":
                filterlist = this.props.items.filter(l=> l.properties.transaction_type == 'Donation');
                
              /*  let removeevents = [];
                for (let rf in filterlist) {
                    let flObj = filterlist[rf];
                    if (flObj.response && flObj.response.type && flObj.response.type !== 'EVENTACK' ) {
                        removeevents.push(flObj)
                    }
                }
                filterlist = removeevents.length ?  removeevents : filterlist;*/
                
                break;
            case "events":
                filterlist = this.props.items.filter(l=> l.properties.transaction_type == 'Event');
                //filterlist = this.props.items.filter(l=> l.eventTotal || (l.response && l.response.type && l.response.type.indexOf('EVENT') !== -1) && !l.productTotal);
               
                break;
            case "orders":
                filterlist = this.props.items.filter(l=> l.properties.transaction_type == 'Order');
                //filterlist = this.props.items.filter(l=> (l.productTotal && !l.donationTotal) || (l.response && l.response.type && l.response.type.indexOf('ORDER') !== -1));
               
                break;
            default:
                filterlist = this.props.items;
                
                break;
        }
        return filterlist;
    }

    handleGotoPage (e, pagenum) {
        
        if (e) {
            e.preventDefault();
        }
        let filterlist = [];
        if (this.state.filtering) {
            filterlist = this.getFilteredListItems (this.state.filteringoption)
        }

        if (this.state.pickerdate.startDate && this.state.pickerdate.endDate) {
            let startDate = new Date(this.state.pickerdate.startDate);
            let endDate = new Date(this.state.pickerdate.endDate);
            filterlist = filterlist.filter(function (a) {
                let listdate = new Date(a.date)
                return listdate >= startDate && listdate <= endDate
            });
        }
       
        let pageInfo = shared.CalcPage(pagenum, this.props, this.state.filtering, filterlist);
        this.setState({pageInfo: pageInfo, page: pagenum});
        this.props.setListItems(pageInfo.data);
    }
    

    handleChange(e, idx) {
        let value = e.target.value;
        let id = e.target.id;
        let elemtype = e.target.type;
        
        let currmem = this.state.workingmember;
        if (elemtype === 'checkbox') {
            value = e.target.checked ? 1 : 0;
        }
        if (elemtype === 'textarea' && e.target.getAttribute('maxLength')) {
            //let maxlength = parseInt(e.target.getAttribute('maxLength'));
            this.setState({biocharacters: value.length});
        }
        if (id === 'ssmtype' || id === 'ssmlink') {
            
            if (currmem.ssms[idx]) {
               switch (id) {
                case "ssmtype":
                    currmem.ssms[idx].type = value;
                    break;
                case "ssmlink":
                    currmem.ssms[idx].link = value;
                    break;
                default:
                    break;
               }
            } 

            this.setState({workingmember: currmem});
        } else {
            
            if (currmem[id] !== undefined) {
                currmem[id] = value;
                this.setState({workingmember: currmem});
            }
        }
    }

    handleExport() {
        
        let memnum = this.state.workingmember.donoraccount;
        let email = this.state.workingmember.email;
        if (parseInt(memnum) && email) {
            this.showProgress('The export file is being processed and will be sent to your inbox at ' + email + '.');
            const afterdownload = () => {
                this.closeProgress('Please check your inbox for your request.');
                this.setState({togglebutton: false});
            }
            let exporturl = variables.buProcessService +  "/getmemtrans?mn=" + memnum + "&em=" + email;
            rests.processrest (exporturl, afterdownload, 'get', {});
        } else {
            setTimeout(() => {
                this.showProgress('Please enter and save your email address above.');
            }, 3000);
            
        }
    }
    
    handleOpenButton() {
        if (!this.state.togglebutton) {
            this.setState({togglebutton: true});
        } else {
            this.setState({togglebutton: false});
        }
    }

    handlePhotoUpload(e) {
        
        let acceptedfiles = ['jpeg','jpg','png','gif'];
        let acceptedfilesize = 3145728;
        this.setState({acceptedfile: true})
        if( e && e.target && e.target.files && e.target.files.length > 0 ) {
            if (e.target.files && e.target.files.length === 1) {
                const file = e.target.files[0];
                let fileextInfo = file.name.split('.');
                let ext = fileextInfo[1];
                
                if (acceptedfiles.includes(ext) && file.size <= acceptedfilesize) {
                    this.showProgress('Processing Photo Please Wait...');
                    const reader = new FileReader();
                    reader.onload = () => {

                        let currmem = this.state.workingmember;
                        currmem.photo = reader.result;
                        currmem.photoapproved = 0;
                        this.setState({workingmember: currmem});
                       
                        let url = variables.buProcessService + '/api/members/processphoto';
                        
                        let attachInfo = {
                            attachtype: 'image',
                            acctnum: this.state.workingmember.donoraccount,
                            attachment: reader.result,
                            attachmentname: file.name
                        }
                        
                        
                        const afterattachment = (attInfo) => {
                           // console.log(attInfo)
                            e.target.value = '';
                            this.closeProgress('Photo has been uploaded');
                        }
                        
                        rests.processrest (url, afterattachment, 'post', attachInfo);
                    }
                    if (file) {
                        reader.readAsDataURL(file)
                    }
                } else {
                    
                    this.setState({acceptedfile: false})
                }
            }
        }
    }

    handleToggleChange(e) {
        //showprofile
        let id = e.target.id;
        let currmem = this.state.workingmember;
        let value = 0;
        if (currmem.showprofile) {
            //this.setState({makepublic: false});
            value = 0;
        } else {
            //this.setState({makepublic: true});
            value = 1;
        }

        if (currmem[id] !== undefined) {
            currmem[id] = value;
            this.setState({workingmember: currmem});
        }
        
    }

    handleValueChange(newValue) {     
        
        let startDate = new Date(newValue.startDate);
        let endDate = new Date(newValue.endDate);
        if (newValue.startDate && newValue.endDate) {
            let currentfilter = this.getFilteredListItems (this.state.filteringoption); //Let's get the listitems from the current options if selected
            let filterlist = currentfilter.filter(function (a) {
                let listdate = new Date(a.date)
                return listdate >= startDate && listdate <= endDate
            });
        
            this.setState({pickerdate: newValue});
            let pageInfo = shared.CalcPage(1, this.props, true, filterlist);
            this.setState({pageInfo: pageInfo, page: 1, filtering: this.state.filtering, filteringoption: this.state.filteringoption});
            this.props.setPageInfo(pageInfo);
            this.props.setListItems(pageInfo.data);
        } else {
            
            this.setState({pickerdate: newValue});

            setTimeout(() => {
                let tabInfo = {
                    slug: this.state.filteringoption
                }
                this.onTabClick (tabInfo, this.state.activeIndex);
            }, 1000);
            
        }
    }

    handleView(docID) {
        let filteredItem = this.props.listitems.filter(l=> l.id == docID);
        this.showProgress('Retrieving Transaction Information.  Please Wait...');
        const aftertrans = (transInfo) => {
            if (filteredItem.length) {
                filteredItem[0]['items'] = transInfo;
                this.setState({workingtransaction: filteredItem, transview: 'viewtransaction', makepublic: false} );
                this.closeProgress('');
            } else {
                this.closeProgress("We're sorry this transaction is not found.");
            }
        }
        let url = variables.buProcessService + '/api/gettransinfo';
        
        let searchInfo = {
            docID: docID
        }
       
        rests.processrest (url, aftertrans, 'post', searchInfo);
    }

    handleSubmit(e) {
        e.preventDefault();
        let url = variables.buProcessService + '/api/members/processportalmember';
           
        const aftersetinfo = (mInfo) => {
            //console.log(mInfo)
            this.closeProgress('Profile has been processed.');
        }
        let currmem = this.state.workingmember;
        currmem.transactions = [];
        currmem.photo = '';
        currmem.process='submitmember';

        //Let's jwt information to send to server
        const jwtSecretKey = variables.jwtscr;
        const token = rests.createjwt(currmem, jwtSecretKey);
        let memInfo = {
            memjwt: token
        }
        //Here we send to the gps database to update information in donor
        this.showProgress('Processing Profile Update.  Please Wait...');
        
        rests.processrest (url, aftersetinfo, 'post', memInfo);
    }

    closeView() {
        this.setState({transview: ''} );
    }

    addressverify(address, city, state) {
        address = address ? address.trim().replace(' ','+') : '';
        city = city ? city.trim().replace(' ', '+') : '';
        
        //const authId = rests.decode(variables.smauthID);
        //const authToken = rests.decode(variables.smauthtoken);
       // const authKey = rests.decode(variables.smwk);
       
        const payload = {
            address: address,
            city: city
        }
        
        const url = variables.buProcessService + "/ecom/searchaddress/";
       
        const afteraddresslookup = (addlookup) => {
            this.setState({addressOptions: addlookup})
        }

        rests.processrest (url, afteraddresslookup, 'post', payload);
       
    }

    handleAddressChange(evt){
        
        if(evt.target.value && evt.target.value.length > 5){
            let address = evt.target.value;
            let city = this.props.workingmember.city ? this.props.workingmember.city : '';
            let state = this.props.workingmember.state ? this.props.workingmember.state : '';

            this.addressverify(address, city, state);
           
        } else {
            this.setState({addressOptions: [], billingaddressOptions: [] })
        }
    }

    autocompleteAddress(term)  {
        const SmartyStreetsCore = SmartyStreetsSDK.core;
        const websiteKey = rests.decode(variables.smwk); // Your Website Key
        const Lookup = SmartyStreetsSDK.usAutocompletePro.Lookup;
        //const authId = rests.decode(variables.smauthID);
        //const authToken = rests.decode(variables.smauthtoken);
        const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
        const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials).withLicenses(["us-autocomplete-pro-cloud"]);
        const client = clientBuilder.buildUsAutocompleteProClient();
        const lookup = new Lookup(term);
        lookup.maxSuggestions = 10;

        const logSuggestions = function (response, message) {
			
			
		}
		async function handleRequest(lookup, lookupType, client) {
			try {
				const results = await client.send(lookup);
				logSuggestions(results, lookupType);
			} catch(err) {
				
			}
		}
		async function processlookup() {		
			await handleRequest(lookup, "Simple Lookup", client);
		}
        processlookup()
        return [];
    }

    filladdress(addID, area) {
        switch (area) {
            case 'billing':
                
                break;
            case 'contact':
               
                let currmem = this.state.workingmember;
                currmem.address1 = this.state.addressOptions[addID].streetLine;
                currmem.city = this.state.addressOptions[addID].city;
                currmem.state = this.state.addressOptions[addID].state;
                currmem.zip = this.state.addressOptions[addID].zipcode;
                
                this.setState({workingmember: currmem, addressOptions: []});
                let addelem = document.getElementById('address1');
                let cityelem = document.getElementById('city');
                let stateelem = document.getElementById('state');
                let zipelem = document.getElementById('zip');
                
                addelem.value = this.state.addressOptions[addID].streetLine;
                cityelem.value = this.state.addressOptions[addID].city;
                stateelem.value = this.state.addressOptions[addID].state;
                zipelem.value = this.state.addressOptions[addID].zipcode;
               

                break;
            default:
                break;
        }
    }

    getmember = () => {
        let cookieuserInfo = JSON.parse(JSON.stringify(this.props.cookies.gpsuser));
        if (!Object.keys(this.state.memberdonorInfo).length && cookieuserInfo.p) {
            const aftergetmember = (mObj) => {
                
                this.props.setuserinfo(mObj.memberdonorInfo);
                this.props.setMemberDonorInfo(mObj.memberdonorInfo);
                this.props.setItems(mObj.memberdonorInfo.transactions);
                this.props.setworkingmember(mObj.workingmember);
                let partnercode = mObj.workingmember.partner ? mObj.workingmember.partner.toLowerCase() : '';
                
                let badgeImg = partnercode && this.badges[partnercode] ? this.badges[partnercode].badge : '';
                let badgeStyle = {
                    backgroundImage:
                        "url('" + badgeImg + "')",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    paddingBottom: "30%"
                };
                setTimeout(() => {
                    let pageInfo = shared.CalcPage(1, this.props);
                    this.setState({memberdonorInfo: mObj.memberdonorInfo, workingmember: mObj.workingmember, pageInfo: pageInfo, badgeImg: badgeImg, badgeStyle: badgeStyle, biocharacters: mObj.workingmember.bio.length});
                    this.props.setListItems(pageInfo.data);
                    
                }, 3000);
                
            }
            if (this.props.userInfo && this.props.userInfo.donoraccount) {
                let partnercode = this.props.userInfo.partner ? this.props.userInfo.partner.toLowerCase() : '';
               
                let badgeImg = partnercode && this.badges[partnercode] ? this.badges[partnercode].badge : '';
                let badgeStyle = {
                    backgroundImage:
                        "url('" + badgeImg + "')",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    paddingBottom: "30%"
                };
                
                setTimeout(() => {
                    let pageInfo = shared.CalcPage(1, this.props);
                    this.setState({memberdonorInfo: this.props.userInfo, workingmember: this.props.workingmember, pageInfo: pageInfo, badgeImg: badgeImg, badgeStyle: badgeStyle, biocharacters: this.props.workingmember.bio.length});
                    this.props.setListItems(pageInfo.data);
                    
                }, 500);
            } else {
                
                rests.getmember (cookieuserInfo.u, cookieuserInfo.p, aftergetmember);
            }
        } else {
            //console.log('information is set already');
        }
    }

    onTabClick (tab, idx) {
        this.setState({activeIndex: idx})
        let listslug = tab.slug;
        let pageInfo = {};
        let onfilter = listslug === 'donations' || listslug === 'events' || listslug === 'orders' ? true : false ;
        let filterlist = this.getFilteredListItems (listslug);
        if (this.state.pickerdate.startDate && this.state.pickerdate.endDate) {
           
            let startDate = new Date(this.state.pickerdate.startDate);
            let endDate = new Date(this.state.pickerdate.endDate);
            filterlist = filterlist.filter(function (a) {
                let listdate = new Date(a.date)
                return listdate >= startDate && listdate <= endDate
            });
        }
        pageInfo = shared.CalcPage(1, this.props, true, filterlist);
        this.setState({pageInfo: pageInfo, page: 1, filtering: onfilter, filteringoption: listslug});
        this.props.setPageInfo(pageInfo);
        this.props.setListItems(pageInfo.data);
        
        
    }

    showProgress = (msg) => {
        this.props.setshowprogress(true);
        this.props.setprogresstxt(msg)
    }

    closeProgress = (msg) => {
        this.props.setshowprogress(true);
        this.props.setprogresstxt(msg);

        setTimeout(() => {
            this.props.setshowprogress(false);
            this.props.setprogresstxt('');
        }, 3000);
    }
    render() {
        
        return (
            <>
                <section id="loading_container" className="bg-white mt-[7%] pb-30 mb-[7%]" >
                    
                        <div className="col-span-12 pt-20 pb-0">
                            <div className="container text-left">
                                <h3 className="text-tprimary font-bold">Account</h3>
                            </div>
                        </div>
                        
                        {Object.keys(this.state.memberdonorInfo).length ? <div className="container text-left pt-10">
                            <div className={`grid  gap-4 ${this.props.isMobile ? 'grid-cols-1' : 'grid-cols-3'}`}>
                                <div className="w-full max-w-full  bg-white border border-gray-200 rounded-lg shadow-gcard dark:bg-gray-800 dark:border-gray-700">
                                    <div className="flex justify-end px-4 pt-4 relative">
                                        
                                    </div>
                                    <div className="flex flex-col items-center pb-10">
                                        <div className="relative bg-ltgray p-3 rounded-full w-128 h-128">
                                            <div className="overlay bg-overlay rounded-full hover:opacity-100">
                                                <div className="flex flex-col items-center justify-center h-100 ">
                                                    <input type="file" id="memberphoto" name="memberphoto" className="absolute opacity-0 h-30 cursor-pointer" onChange={(e)=> this.handlePhotoUpload(e)} accept=".jpeg,.jpg,.png,.gif"/>
                                                    <BiSolidCameraPlus className="font-medium text-xl text-white"/>
                                                    <p className="text-white text-sm">Update photo</p>
                                                </div>
                                            </div>
                                            {this.state.workingmember.photo ? <img className="w-24 h-24 rounded-circle" src={this.state.workingmember.photo} alt="GPS Member"/> : <FaRegUser className="w-24 h-24 rounded-circle text-white"/>}
                                        </div>
                                        <p className="mt-1 text-ltgray text-sm leading-6 ">Allowed *.jpeg, *.jpg, *.png, *.gif. <br></br>Max size of 3 MB</p>
                                        {!this.state.acceptedfile ? <p className="text-danger text-sm leading-6">This file is unacceptable.  Please try again.</p> : <></>}
                                        
                                        {this.state.workingmember.photo && !parseInt(this.state.workingmember.photoapproved) ? <p className="text-danger">Photo pending approval</p> : <></>}
                                        {this.state.workingmember.photo && parseInt(this.state.workingmember.photoapproved) ? <p className="text-success">Photo approved</p> : <></>}
                                        <h5 className="mb-1 text-xl font-medium text-tprimary">{this.state.workingmember.firstname}  {this.state.workingmember.lastname} </h5>
                                        <span className="text-sm text-gray-500 dark:text-gray-400">{this.state.workingmember.partnerdesc}</span>
                                        <div className=" w-[20%] bg-right right-[5%] top-[5%]" style={this.state.badgeStyle}></div>
                                        <span className="text-sm text-gray-500 dark:text-gray-400">{this.state.workingmember.donoraccount}</span>
                                        
                                        <p className="text-tsecondary text-sm leading-6 p-3 mt-10">The items below determine whether or not your profile information appears on the networking page. You can also determine which areas of your profile you would like to make public. </p>

                                        <label className="inline-flex items-center cursor-pointer mt-2 relative">
                                            <input type="checkbox" value="" className="sr-only peer" defaultChecked={this.state.workingmember.showprofile}/>
                                            <span className="ms-3 text-sm font-medium text-tprimary mr-5">Public Profile {this.state.workingmember.showprofile ? <span className="text-success">(on)</span> : <span className="text-danger">(off)</span>} </span>
                                            <div id="showprofile" name = "showprofile" className="relative w-11 h-6 bg-ltgray peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-bgblue  rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-bgblue" onClick={(e)=> this.handleToggleChange(e)}></div>
                                        
                                        </label>
                                        {this.state.workingmember.showprofile ? <p className="text-danger text-sm leading-6 p-3 font-bold">Please note that your photo will have to be approved prior to being shown in the GPS member business network</p> : <></>}
                                        <ul className="mt-1 w-[80%] m-auto">
                                            <li>
                                                <div className="flex items-center mb-2 relative">
                                                    <input id="showtitle" name="showtitle" type="checkbox" defaultValue={this.state.workingmember.showtitle} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" defaultChecked={this.state.workingmember.showtitle} onClick={(e)=> this.handleChange(e, 0)}/>
                                                    <label htmlFor="showtitle" className="ms-2 text-sm font-medium text-tprimary dark:text-tprimary">Show title</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="flex items-center mb-2 relative">
                                                    <input id="showcompany" name="showcompany" type="checkbox" defaultValue={this.state.workingmember.showcompany} defaultChecked={this.state.workingmember.showcompany}  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" onClick={(e)=> this.handleChange(e, 0)}/>   
                                                    <label htmlFor="showcompany" className="ms-2 text-sm font-medium text-tprimary dark:text-tprimary">Show company name</label>
                                                </div>
                                               
                                            </li>
                                            <li>
                                                <div className="flex items-center mb-2 relative">
                                                    <input id="showsocialmedia" name="showsocialmedia" type="checkbox" defaultValue={this.state.workingmember.showsocialmedia} defaultChecked={this.state.workingmember.showsocialmedia} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" onClick={(e)=> this.handleChange(e, 0)}/>
                                                    <label htmlFor="showsocialmedia" className="ms-2 text-sm font-medium text-tprimary dark:text-tprimary">Show social media icons</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="flex items-center mb-2 relative">
                                                    <input id="openconnection" name="openconnection" type="checkbox" defaultValue={this.state.workingmember.openconnection}  defaultChecked={this.state.workingmember.openconnection} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" onClick={(e)=> this.handleChange(e, 0)} />
                                                    <label htmlFor="openconnection" className="ms-2 text-sm font-medium text-tprimary dark:text-tprimary">Open to connections</label>
                                                </div>
                                            </li>

                                            <li>
                                                <div className="flex items-center mb-2 relative">
                                                    <input id="showemail" name="openconneshowemailction" type="checkbox" defaultValue={this.state.workingmember.showemail}  defaultChecked={this.state.workingmember.showemail} className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" onClick={(e)=> this.handleChange(e, 0)} />
                                                    <label htmlFor="showemail" className="ms-2 text-sm font-medium text-tprimary dark:text-tprimary">Receive emails</label>
                                                </div>
                                            </li>

                                            
                                        </ul>
                                    </div>
                                </div>
                                <div className={`col-span-2 p-4 bg-white border border-gray-200 rounded-lg shadow-gcard ${this.props.isMobile ? 'col-span-2' : 'col-span-2'}`}>
                                    <form id="memberinformation" className="bg-white pt-6 pb-8 mb-4" action='' method="post" onSubmit={(e) => this.handleSubmit(e)}>
                                        <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                            <div className="relative mb-2">
                                                <input type="text" id="firstname" name="firstname" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.firstname} onBlur={(e)=> this.handleChange(e, 0)} required/>
                                                <label htmlFor="firstname" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">First Name<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2">
                                                <input type="text" id="lastname" name="lastname" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.lastname} onBlur={(e)=> this.handleChange(e, 0)} required/>
                                                <label htmlFor="lastname" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Last Name<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2">
                                                <input type="text" id="title" name="title" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.title} onBlur={(e)=> this.handleChange(e, 0)}/>
                                                <label htmlFor="title" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Title</label>
                                            </div>

                                            <div className="relative mb-2">
                                                <input type="text" id="company" name="company" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.company} onBlur={(e)=> this.handleChange(e, 0)}/>
                                                <label htmlFor="company" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Company</label>
                                            </div>

                                            <div className="relative mb-2 col-span-2">
                                                <input type="text" id="email" name="email" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.email} onBlur={(e)=> this.handleChange(e, 0)} required/>
                                                <label htmlFor="email" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Email Address<span className="text-danger">*</span></label>
                                            </div>

                                            

                                            <div className="relative mb-2">
                                                <input type="text" id="address1" name="address1" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.address1} onChange={(e)=> this.handleAddressChange(e)}required/>
                                               {this.state.addressOptions.length ? <div className="suggestions">
                                                    <ul>
                                                        {this.state.addressOptions.map((a, i)=> {
                                                            
                                                            return (
                                                            <li key={Math.random()} onClick={(e)=> this.filladdress(i, 'contact')}>
                                                                <span>{a.streetLine}</span>,&nbsp;
                                                                <span>{a.city}</span>,&nbsp;
                                                                <span>{a.state}</span>&nbsp;&nbsp;
                                                                <span>{a.zipcode}</span>
                                                            </li>)
                                                        })}
                                                    </ul>
                                                </div> : <></>}
                                                <label htmlFor="address1" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Address 1<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2"> 
                                                <input type="text" id="address2" name="address2" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.address2} onBlur={(e)=> this.handleChange(e, 0)}/>
                                                <label htmlFor="address2" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Address 2</label>
                                            </div>

                                            <div className="relative mb-2">
                                                <input type="text" id="city" name="city" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.city} onBlur={(e)=> this.handleChange(e,0)} required/>
                                                <label htmlFor="city" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">City<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2">
                                                <select id="state" name="state" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" value={this.state.workingmember.state} onChange={(e)=> this.handleChange(e,0)} required>
                                                    <option value="">Select</option>
                                                    {this.state.stateoptions &&
                                                        this.state.stateoptions.map (opt => ( <option key={Math.random()} value={opt.id} >
                                                            {opt.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            
                                                <label htmlFor="state" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">State<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2">
                                                <input type="text" id="zip" name="zip" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.zip} onBlur={(e)=> this.handleChange(e,0)} required/>
                                                <label htmlFor="city" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Postal Code<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2">
                                                <select id="country" name="country" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" value={this.state.workingmember.country === 'USA' ? 'US' : this.state.workingmember.country} onChange={(e)=> this.handleChange(e,0)} required>
                                                    <option value="">Select</option>
                                                    {this.countryoptions &&
                                                        this.countryoptions.map ((opt) => ( <option key={Math.random()} value={opt.id} >
                                                            {opt.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            
                                                <label htmlFor="country" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Country<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2 col-span-2">
                                                

                                                <input type="text" id="phone" name="phone" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="" defaultValue={this.state.workingmember.phone} onBlur={(e)=> this.handleChange(e,0)} />
                                                
                                                
                                                <label htmlFor="city" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Phone<span className="text-danger">*</span></label>
                                            </div>

                                            <div className="relative mb-2 col-span-2">
                                                <textarea id="bio" className="block rounded px-3 pb-2.5 pt-3 w-full text-sm text-gray-900 border border-b-2 border-gray-300 min-h-[250px] appearance-none border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" maxLength={1500} placeholder="" value={this.state.workingmember.bio} onChange={(e)=> this.handleChange(e,0)}/>
                                                <label htmlFor="bio" className="absolute bg-white text-sm text-ltgray text-700 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] start-2.5 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">Brief Introduction</label>
                                                <p className="text-sm text-right w-100 text-tsecondary"><em>Maximum 1500 characters<br/>{this.state.biocharacters}/1500 characters</em></p>
                                            </div>

                                            <div className="relative mb-2 col-span-2">
                                                <p className="text-tprimary"><b>Social Media Links</b></p>
                                                <div className="flex">
                                                    <div className="col-md-5 my-3">
                                                        <p className="text-tprimary">Social Media Type</p>
                                                    </div>
                                                    <div className="col-md-5 my-3">
                                                        <p className="text-tprimary">Social Media Link</p>
                                                    </div>
                                                </div>
                                                {this.state.workingmember && this.state.workingmember.ssms ? this.state.workingmember.ssms.map ((item, idx) => ( <SocialMediaBlock key={Math.random()} {...this.allprops} {...item} idx={idx}/>)) : <></>}
                                            </div>          
                                        </div>
                                        <div className="flex items-center justify-end mt-10">
                                            <input type="submit" value="Save Changes" className="bg-bgblue hover:bg-bgbluehover text-left text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-[5%]">
                                <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-gcard">
                                    <div className="flex justify-end px-4 pt-4 relative">
                                            <button id="dropdownButton" data-dropdown-toggle="dropdown" className="inline-block text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-1.5" type="button" onClick={(e) => this.handleOpenButton()}>
                                                <span className="sr-only">Open dropdown</span>
                                                <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 3">
                                                    <path d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>
                                                </svg>
                                            </button>
                                            
                                            <div id="dropdown" hidden={!this.state.togglebutton} className="absolute z-10 mt-[2.3%] text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
                                                <ul className="py-0 px-0" aria-labelledby="dropdownButton">
                                                    <li>
                                                        <div className="block px-2 py-2 text-sm text-tprimary cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-tprimary dark:hover:text-white" onClick={(e) => this.handleExport()}>Export CSV Data</div>
                                                    </li>
                                                </ul>
                                            </div>
                                    </div>
                                    <h3 className="text-tprimary font-bold">Giving History</h3>
                                    <p className="leading-7"><b>Please Note:</b>  This transaction list shows only transactions within the last 5 years and what has been currently verified within our system.  It may not include the most recent transactions but will have those here shortly.</p>
                                    {this.state.pageInfo.total_pages ? <Pagination {...this.allprops} pInfo={this.state.pageInfo} pagenum={this.state.page}  /> : <></>}
                                    <div className="relative overflow-x-auto mt-[3%]">
                                        <div id="donation-container" className="flex flex-row mb-[40px] gap-[40px]">
                                            {this.tabs.map((item, index) => {
                                                return (
                                                <div id="tabs-container-profile" className={`${index === this.state.activeIndex ? 'bg-bgblue' : 'bg-bgltblue'} cursor-pointer border-bgblue border-0 border-solid flex justify-center items-center px-[40px] rounded-[20px]`}
                                                    onClick={() => this.onTabClick(item, index)}
                                                    key={Math.random()}
                                                >
                                                    <h6 id="tab" className={`self-center ${index === this.state.activeIndex ? "text-white" : "text-bgblue"} mt-1`}>
                                                    {item.cat}
                                                    </h6>
                                                </div>
                                                );
                                            })}
                                            <div className="flex items-center justify-between space-x-2">
                                                <div className="text-tprimary hidden">Filter By Date</div>
                                                <div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                                            <thead className="text-xs text-tsecondary uppercase bg-neutral">
                                                <tr>
                                                    <th scope="col" className="px-6 py-3">
                                                        Amount
                                                    </th>
                                                    <th scope="col" className="px-6 py-3">
                                                        Transaction#
                                                    </th>
                                                    <th scope="col" className="px-6 py-3">
                                                        Type
                                                    </th>
                                                    <th scope="col" className="px-6 py-3">
                                                        Transaction Date
                                                    </th>
                                                    <th scope="col" className="px-6 py-3">View</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-tprimary">
                                                {this.props.listitems && this.props.listitems.length ? this.props.listitems.map(opt => <ListItem key={Math.random()} {...this.allprops} opt={opt}/>) : <tr className="bg-white border-dashed border-b ">
                                                <td className="px-6 py-4" colSpan={"3"}><h4>No Items To view.</h4></td></tr>}
                                            </tbody>
                                        </table>
                                        {this.state.transview === 'viewtransaction' ? <Portal><TransactionView {...this.allprops} workingtransaction={this.state.workingtransaction} memInfo={this.state.memberdonorInfo}/></Portal>: <></>}
                                    </div>
                                    {this.state.pageInfo.total_pages ? <Pagination {...this.allprops} pInfo={this.state.pageInfo} pagenum={this.state.page}  /> : <></>}
                                </div>
                            </div>
                        </div> : <><div className="container text-left pt-10"><h2>We are gathering your information... Please wait...</h2></div></>
                    }
                    
                </section>
                <Connect {...this.props} bgblue={true}/>
            </>
        )
    }
};

export default MemberProfile;